import { Deserializable } from "../shared/models/deserializable.model";
import { Injectable } from '@angular/core';
import { WorkItem } from './work-item';
import { Contact } from './contact';
import { Business } from './business';
import { Property } from './property';
import { Job } from './job';
import { EmailSendLog } from './email-send-log';
import { Gallery } from './gallery';

import { map } from 'rxjs/operators';

export interface QuoteRelations {
  contact?: Contact;
  property?: Property;
  business?: Business;
  job?: Job;
  gallery?: Gallery;
  workItems?: WorkItem[];
  emailSendLogs?: EmailSendLog[];
}

export class Quote implements Deserializable {
   accountId: number;
   id: number;
   description: string;
   description_position: string;
   publidId: string;
   quote_number: string;
   quote_date: string;
   isSent: boolean;
   isAccepted: boolean;
   createdAt: Date;
   updatedAt: Date;
   chargesTotal: number;
   balance: number;
   contactId: number;
   propertyId: number;
   businessId: number;
   currency: string;
   jobId: number;
   galleryId: string;
   WorkItems: WorkItem[];
   EmailSendLogs: EmailSendLog[];
   Contact: Contact;
   Property: Property;
   Business: Business;
   Job: Job;
   Gallery: Gallery;
   total: any;
   quoteWebLink: string;
   status: string;

   constructor() {
    this.isSent = false;
    this.isAccepted = false;
    this.WorkItems = [];
   }

   deserialize(input: any) {
   	Object.assign(this, input);

      // Map Work Items to Model
      if (input.WorkItems && input.WorkItems.length > 0) {
         this.WorkItems = input.WorkItems.map((workitem: any) => new WorkItem().deserialize(workitem));
      }
      else {
         this.WorkItems = [];
      }

      if (input.Contact)
         this.Contact = new Contact().deserialize(input.Contact);
      if (input.Property)
         this.Property = new Property().deserialize(input.Property);
      if (input.Business)
         this.Business = new Business().deserialize(input.Business);
      if (input.Job)
         this.Job = new Job().deserialize(input.Job);
      if (input.Gallery)
         this.Gallery = new Gallery().deserialize(input.Gallery);

      // Created & updated
      this.createdAt = new Date(Date.parse(input.createdAt));
      this.updatedAt = new Date(Date.parse(input.updatedAt));

      return this;
  }

  get getTotal(): any {

     var total = 0;
     var totalTax = 0;
     var totalIncTax = 0;
     var balance = 0;
     var payments = 0;

     if (this.WorkItems && this.WorkItems.length > 0) {
        
        // Start running some calcaulations for Work Items
        for (var i = 0 ; i < this.WorkItems.length; i++) {
           var subTotal = this.WorkItems[i].quantity * this.WorkItems[i].rate*0.01;
           var subTax = subTotal * (this.WorkItems[i].taxRate / 100);

           // Add to running total
           total += subTotal;

           if (this.WorkItems[i].hasTax) {
              totalTax += subTax;
              totalIncTax += subTotal + subTax;
           }
           else {
              totalIncTax += subTotal;
           }

        }
     }

     return {
        total: total,
        totalTax: totalTax,
        totalIncTax: totalIncTax,
        balance: balance
     }
   }

  updateWorkItem(id: number, updatedWorkItem: WorkItem): void {
     // find the Work Item in this.workItems using the ID and update it
     const index = this.WorkItems.findIndex(item => item.id === id);
     if (index !== -1) {
      this.WorkItems[index] = updatedWorkItem;
     }
  }

  updateWorkItemByIndex(index: number, updatedWorkItem: WorkItem): void {
   this.WorkItems[index] = updatedWorkItem;
  }

  deleteWorkItem(id: number): void {
     // find the Work Item in this.workItems using the ID and update it
     const index = this.WorkItems.findIndex(item => item.id === id);
     if (index !== -1) {
      this.WorkItems.splice(index, 1);
     }
  }

  addWorkItem(workItem: WorkItem): void {
   this.WorkItems.push(workItem);
  }
}